import { Component, ChangeDetectionStrategy, Inject, LOCALE_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`:host { display: block; min-height: 100vh; }`],
})
/** Root component of the Angular application. */
export class AppComponent {
  /** Ensures native date/time inputs use the app locale for display. */
  constructor(@Inject(LOCALE_ID) locale: string) {
    document.documentElement.lang = locale;
  }
}
